'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _dec2, _class, _class2, _temp;

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _Images = require('./Images.scss');

var _Images2 = _interopRequireDefault(_Images);

var _reactRedux = require('react-redux');

var _gallery = require('redux/modules/gallery');

var _reactIntl = require('react-intl');

var _media = require('utils/media');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  Images: {
    displayName: 'Images'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/components/TripDetail/Images.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var Images = _wrapComponent('Images')((_dec = (0, _reactRedux.connect)(function () {
  return {};
}, { openAndGoTo: _gallery.openAndGoTo }), _dec2 = (0, _reactCssModules2.default)(_Images2.default), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Images, _Component);

  function Images(props) {
    (0, _classCallCheck3.default)(this, Images);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Images.__proto__ || (0, _getPrototypeOf2.default)(Images)).call(this, props));

    _this.getImages = _this.getImages.bind(_this);

    if (!(typeof _this.getImages === 'function')) {
      throw new TypeError('Value of "this.getImages" violates contract.\n\nExpected:\n() => any\n\nGot:\n' + _inspect(_this.getImages));
    }

    return _this;
  }

  (0, _createClass3.default)(Images, [{
    key: 'getImages',
    value: function getImages() {
      var trip = this.props.trip;

      if (trip.video_url) {
        // return [{video: {backgroundImage: `url(https://img.youtube.com/vi/${trip.video_url}/0.jpg)`}}, ...trip.images];
        return [{ video: 'https://img.youtube.com/vi/' + trip.video_url + '/0.jpg' }].concat((0, _toConsumableArray3.default)(trip.images));
      }
      return trip.images;
    }
  }, {
    key: 'openGallery',
    value: function openGallery(index) {
      this.props.openAndGoTo(index);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var trip = this.props.trip;

      return _react3.default.createElement(
        'div',
        { styleName: 'trip-images' },
        this.getImages().map(function (image, index) {
          return _react3.default.createElement(
            'div',
            { key: 'gallery-' + index, styleName: index <= 4 ? 'image-container' : 'image-container-preload' },
            _react3.default.createElement(
              'div',
              { styleName: 'image', onClick: _this2.openGallery.bind(_this2, index) },
              _react3.default.createElement('img', { src: image.video ? image.video : (0, _media.path)(image.image, 'thumbnail'), styleName: 'image-img', alt: image.caption || trip.name }),
              index === 0 && trip.video_url && _react3.default.createElement('div', { styleName: 'play-gallery' }),
              (index === 3 || index === 4) && _react3.default.createElement(
                'div',
                { styleName: index === 3 ? 'image-shadow-mobile' : 'image-shadow' },
                _react3.default.createElement(
                  'span',
                  null,
                  _react3.default.createElement(_reactIntl.FormattedMessage, { id: 'trip.detail.images.see_all', values: { images: trip.images.length } })
                )
              )
            )
          );
        })
      );
    }
  }]);
  return Images;
}(_react2.Component), _class2.propTypes = {
  trip: _react2.PropTypes.object,
  openAndGoTo: _react2.PropTypes.func
}, _temp)) || _class) || _class));

exports.default = Images;

function _inspect(input, depth) {
  var maxDepth = 4;
  var maxKeys = 15;

  if (depth === undefined) {
    depth = 0;
  }

  depth += 1;

  if (input === null) {
    return 'null';
  } else if (input === undefined) {
    return 'void';
  } else if (typeof input === 'string' || typeof input === 'number' || typeof input === 'boolean') {
    return typeof input === 'undefined' ? 'undefined' : (0, _typeof3.default)(input);
  } else if (Array.isArray(input)) {
    if (input.length > 0) {
      if (depth > maxDepth) return '[...]';

      var first = _inspect(input[0], depth);

      if (input.every(function (item) {
        return _inspect(item, depth) === first;
      })) {
        return first.trim() + '[]';
      } else {
        return '[' + input.slice(0, maxKeys).map(function (item) {
          return _inspect(item, depth);
        }).join(', ') + (input.length >= maxKeys ? ', ...' : '') + ']';
      }
    } else {
      return 'Array';
    }
  } else {
    var keys = (0, _keys2.default)(input);

    if (!keys.length) {
      if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
        return input.constructor.name;
      } else {
        return 'Object';
      }
    }

    if (depth > maxDepth) return '{...}';
    var indent = '  '.repeat(depth - 1);
    var entries = keys.slice(0, maxKeys).map(function (key) {
      return (/^([A-Z_$][A-Z0-9_$]*)$/i.test(key) ? key : (0, _stringify2.default)(key)) + ': ' + _inspect(input[key], depth) + ';';
    }).join('\n  ' + indent);

    if (keys.length >= maxKeys) {
      entries += '\n  ' + indent + '...';
    }

    if (input.constructor && input.constructor.name && input.constructor.name !== 'Object') {
      return input.constructor.name + ' {\n  ' + indent + entries + '\n' + indent + '}';
    } else {
      return '{\n  ' + indent + entries + '\n' + indent + '}';
    }
  }
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TripDetail/Images.js
// module id = 1632
// module chunks = 0